import { Reporter, visibilityObserver } from 'features/dataCapture';
import { visibilityObserver as productVisibilityObserver } from 'features/product';
import { initStickyHeaderSearch } from 'features/stickyHeaderSearch';
import { ProductImpressionsReporter, utagLinkSort } from 'features/tealium';
import { trackDyRecommendedItemClickEvent } from 'features/tealium/dynamicYield/recommendedItemsTracking';
import { ProductImpressionsReporter as ProductImpressionsGa4Reporter, utagLinkSelectItem } from 'features/tealium/ga4/ecommerce';

(() => {

	const moreLikeThisContainer = document.querySelector('.moreLikeThis');

	function onLoad () {

		if (moreLikeThisContainer) {

			const dataSkuArr = window.location.pathname.split('/more-like-this/');
			const dataSku = dataSkuArr[1]?.replace('/', '');
			utagLinkSort('More Like This')({
				eventAction:
					Array.isArray(window.utag_data.product_islpproduct)
					&& Number(window.utag_data.product_islpproduct.join('')) > 0
						? 'IsLPSKUTrue'
						: 'IsLPSKUFalse',
				eventLabel: dataSku,
				nonInteraction: 1
			});

			moreLikeThisContainer.addEventListener('click', (e) => {

				const el = e.target;

				if (el.classList.contains('TTreadReviews')) {

					document.location.href = `${el.dataset.url}#readreviews`;

				}

				if (el.classList.contains('sortMoreLikeThisBtn')) {

					const parentElement = el.parentElement.parentNode;
					utagLinkSort('More Like This')({
						eventAction: 'Click-More-Like-This',
						eventLabel: parentElement.querySelector('[data-sku]').getAttribute('data-sku')
					});

				}

			});

		}

		if (window.lp.globals.canShowCertona) {

			window.lp.certona.getRecommendedItems();

		}

	}

	function initializeDataCapture () {

		if (!window.lp.globals.enableDataCapture || !moreLikeThisContainer) {

			return;

		}

		const { reporter } = window.lp.dataCapture;
		const observer = visibilityObserver((element) => {

			const data = Reporter.getSkuViewData(element);
			reporter.track(data);

		});

		document.addEventListener('recommendedItems:glo_MLT_sort:loaded', () => {

			const skuViews = moreLikeThisContainer.querySelectorAll('img[data-sku]');
			skuViews.forEach((element) => observer.observe(element));

			const moreLikeThisWidget = document.querySelectorAll('[data-capture-section="MoreLikeThisSortedResults"] a');
			if (moreLikeThisWidget.length) {

				trackDyRecommendedItemClickEvent({ selector: moreLikeThisWidget });

			}

		});

		document.addEventListener('recommendedItems:loaded', () => {

			const trackingElements = document.querySelectorAll(
				'[data-capture-section="MoreLikeThisSortedResults"] img[data-sku]'
			);

			trackingElements.forEach((elem) => observer.observe(elem));

		});

	}

	function initCaptureProductImpressions () {

		const reporter = new ProductImpressionsReporter({
			list_type: null,
			product_grouping: window.utag_data.product_grouping
		});

		const reporterGa4 = new ProductImpressionsGa4Reporter({
			product_grouping: window.utag_data.product_grouping
		});

		const observer = productVisibilityObserver((element) => {

			const record = reporter.getProductImpressionDataFromElement(element);
			reporter.track(record);

			const recordGa4 = reporterGa4.getProductImpressionDataFromElement(element);
			reporterGa4.track(recordGa4);

		});

		document.addEventListener('recommendedItems:loaded', () => {

			const elements = document.querySelectorAll('.sortResultImgContainer img[data-sku]');
			elements.forEach((element) => {

				observer.observe(element);

			});

		});

	}

	function handleProductClickEvent (e) {

		const captureElement = e.currentTarget.querySelector('img[data-sku]');
		if (captureElement) {

			utagLinkSelectItem({
				sku: captureElement.dataset.sku,
				name: captureElement.dataset.name || captureElement.title,
				price: captureElement.dataset.price,
				skuInputType: captureElement.dataset.skuInputType,
				primaryCategory: captureElement.dataset.primaryCategory
			});

		}

	}

	function initProductClickEvents () {

		document.addEventListener('recommendedItems:loaded', () => {

			document.querySelectorAll('.sortResultContainer a[data-has-product-click]').forEach((element) => element.addEventListener('click', handleProductClickEvent, { once: true }));

		});

	}

	initializeDataCapture();
	initCaptureProductImpressions();
	initProductClickEvents();
	initStickyHeaderSearch();

	document.addEventListener('DOMContentLoaded', onLoad);

})();
